module.exports = __webpack_public_path__ + "static/venice20890-3f17dd93b609c512d44d287af834f764.webp";